import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import { Subject } from 'rxjs';

@Component({
  selector: 'control-radio',
  templateUrl: './control-radio.component.html',
  styleUrls: ['./control-radio.component.scss'],
})
export class ControlRadioComponent implements OnInit, OnDestroy {
  @Input('sfcontrol') _sfcontrol: SpecialFormControl;
  @Input('description') _description: string = '';
  private _finisher = new Subject<void>();

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._finisher.next();
  }

  radioChange(value: any) {
    this._sfcontrol.setValue(value.value)
  }

}
